import React from "react";
import { FileText, ClipboardList, Target, Info } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { CategoryResources } from "@/components/CategoryResources";
import { SectionHeading } from "@/components/ResourceCard";
import { IMG } from "@/lib/assets";

const GUIDES = [
  { icon: FileText, title: "Grant Application Basics", desc: "Understand grant types, eligibility, and what reviewers look for." },
  { icon: ClipboardList, title: "Grant Writing Checklist", desc: "A step-by-step checklist to prepare a strong application." },
  { icon: Target, title: "Deadline & Opportunity Tracker", desc: "Keep track of opportunities and their deadlines in the Marketplace." },
];

export default function Grants() {
  return (
    <main>
      <PageHero overline="Funding & Grants Resource Center" image={IMG.entrepreneur}
        title="Verified funding and assistance opportunities"
        subtitle="Government programs, nonprofit grants, scholarships, and small-business technical assistance. The Foundation does not guarantee funding and does not act as a lender." />

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20">
        <div className="flex items-start gap-4 bg-amber-50 border border-amber-200 rounded-2xl p-6 mb-12">
          <Info className="h-6 w-6 text-gold shrink-0 mt-0.5" />
          <p className="text-sm text-amber-900 leading-relaxed">
            <strong>Important:</strong> Millionaire Mindsetters Foundation lists verified opportunities for informational equity.
            We do not guarantee that you will receive funding, and we are not a lender. All third-party programs are provided
            by and subject to the terms of their actual providers.
          </p>
        </div>

        <SectionHeading overline="Resource Guides" title="Tools to help you apply with confidence" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {GUIDES.map((g, i) => (
            <div key={i} className="card-hover bg-white rounded-2xl border border-slate-200 p-7">
              <div className="h-14 w-14 rounded-2xl bg-navy-900 text-gold-light flex items-center justify-center mb-5"><g.icon className="h-7 w-7" /></div>
              <h3 className="font-display text-lg font-bold text-navy-900">{g.title}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{g.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <CategoryResources category="grants-financial-assistance" overline="Verified Directory"
        title="Grants & financial assistance"
        subtitle="Verified funding and assistance programs from government and nonprofit providers."
        categoryName="Grants & Funding" />

      <CategoryResources category="entrepreneurship" overline="Business Support"
        title="Entrepreneurship & business resources"
        subtitle="Free and low-cost technical assistance for small business owners."
        categoryName="Entrepreneurship" />
    </main>
  );
}
